<header-title [model]="headerTitle"></header-title>

<section class="card mt-4">
    <header class="card-header">
        <h3 class="text-gray-600 m-0"><i class="fas fa-tasks me-2"></i>{{ headerTitle?.title }}</h3>
    </header>
    <div class="card-body py-5">
        <div class="container">
            <form *ngIf="questionBankDetailsFormGroup" (submit)="updateModule()" [formGroup]="questionBankDetailsFormGroup">
                <section class="panel">
                    <div class="panel-body">

                        <error-message [errors]="errors"></error-message>

                        <div class="row mt-3">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">
                                        Name
                                    </label>
                                    <h6 *ngIf="!isEditMode">{{questionBankDetailsFormGroup.value.name}}</h6>
                                    <input *ngIf="isEditMode" type="text" class="form-control" formControlName="name" />
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label class="control-label">
                                        Nr Of Optional Questions
                                    </label>
                                    <h6 *ngIf="!isEditMode">{{questionBankDetailsFormGroup.value.nrOptionalQuestions}}</h6>
                                    <input *ngIf="isEditMode" type="text" class="form-control" formControlName="nrOptionalQuestions" />
                                </div>
                            </div>
                            <div class="col-md-3 text-end">
                                <div class="form-group">
                                    <button *ngIf="isEditMode && !questionBankQuestions?.length" type="button" class="btn btn-danger mt-4" (click)="selectedQuestionBankId=questionBankDetailsFormGroup.value.id; confirmation.showMessage();">Delete Question Bank</button>
                                    <button *ngIf="isEditMode && questionBankQuestions?.length>0" type="button" class="btn btn-danger mt-4" (click)="openCannotDeleteQuestionBank(cannotDeleteQuestionBank);">Delete Question Bank</button>
                                </div>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-md-12">
                                <header class="panel-heading">
                                    <h4 class="panel-title text-primary">Existing Questions</h4>
                                </header>
                                <div class="tab-content">
                                    <div id="popular" class="tab-pane active">
                                        <app-question-bank-question-list (questionBankQuestionsUpdated)="questionBankQuestionsUpdated()"
                                                                         [questionBankId]="questionBankId"
                                                                         [isEditMode]="isEditMode">
                                        </app-question-bank-question-list>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <footer class="panel-footer mt-3">
                        <div class="row">
                            <div class="col text-end">
                                <button class="btn btn-outline-primary ms-2" type="button" (click)="onBack()" *ngIf="!isEditMode">Back</button>
                                <button class="btn btn-primary ms-2" type="button" (click)="toggleEditMode()" *ngIf="!isEditMode">Edit</button>
                                <button class="btn btn-outline-primary ms-2" type="button" (click)="toggleEditMode()" *ngIf="isEditMode">Cancel</button>
                                <button class="btn btn-success ms-2" type="submit" *ngIf="isEditMode">Save</button>
                            </div>
                        </div>
                    </footer>
                </section>
            </form>
        </div>
    </div>
</section>

<app-alert-message (successClicked)="successClicked($event)"
                   (onHide)="onHide($event)"
                   [title]="'Success'"
                   [message]="'The Question Bank Updated'">
</app-alert-message>

<app-confirmation-message #confirmation (confirmationClicked)="deleteQuestionBank();"
                          [title]="'Confirmation'"
                          [message]="'Are you sure you want to remove this Question Bank?'">
</app-confirmation-message>

<ng-template #cannotDeleteQuestionBank let-modal>
    <div class="modal-header">
        <div class="container">
            <div class="row">
                <div class="col-10">
                    <div class="row">
                        <div class="col-12">
                            <h4 class="modal-title" id="modal-basic-title">Question Banks with assigned Questions cannot be deleted.</h4>
                        </div>
                        <div class="col-12">
                            <p id="modal-basic-content">Remove all Questions to continue.</p>
                        </div>
                    </div>
                </div>
                <div class="col-2">
                    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</ng-template>
